import { RefreshOutline24Icon } from "@vygruppen/spor-icon-react";
import { PanelAction } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/ActionsOverflowMenu";
import AddVehicle from "features/VehicleSidebar/VehicleList/AddVehicles/AddVehicle";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReserveAlternativeTransport } from "shared/types/alternativeTransport";

/**
 * "Endre til reserve" action. Backup buses only. A plan-originated bus is managed in Hastus and is
 * not offered this action.
 */
export const useConvertToReserveAction = (
  vehicle: ReserveAlternativeTransport,
): PanelAction => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  return {
    key: "convertToReserve",
    label: t("Endre til reserve"),
    leftIcon: <RefreshOutline24Icon />,
    buttonVariant: "tertiary",
    buttonSize: "sm",
    buttonTitle: t("Endre beredskapsbuss til reservebuss"),
    onSelect: () => setShowModal(true),
    modal: showModal ? (
      <AddVehicle
        editVehicle={{ ...vehicle, serviceType: "RESERVE" }}
        isReserveBusTabSelected
        closeModal={() => setShowModal(false)}
      />
    ) : null,
  };
};
